import server from "../statics/server";
import axios from "axios";

export default {
  methods: {
    initEditor: function ({selector, contentName}) {
      const that = this;
      window.tinymce.init({
        selector,
        height: 500,
        branding: false,
        plugins: [
          "advlist autolink lists link image charmap print preview anchor",
          "searchreplace visualblocks code fullscreen",
          "insertdatetime media table paste imagetools wordcount",
        ],
        toolbar: "insertfile undo redo | styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image",
        images_upload_handler: function(blobInfo, success) {
          const formData = new FormData();
          formData.append("file", blobInfo.blob(), blobInfo.filename());
          axios.post(`${server.addr()}${server.api.FILE}`, formData)
            .then(response => success(`${server.addr()}/download/${response.data}`));
        },
        setup: function(editor) {
          editor.on("init", function() {
            editor.setContent(that.data[contentName]);
          });
          editor.on("change", function() {
            that.data[contentName] = editor.getContent();
          });
        },
      })
      // .then((r) => (that[editorContentName] = r[0]));
    },
  },
};